import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss'
})
export class PaginationComponent {

  @Input() totalItems: number = 1000; // Total number of items
  @Input() itemsPerPage: number = 10; // Items per page
  @Input() currentPage: number = 1; // Current page
  
  @Output() pageChange: EventEmitter<number> = new EventEmitter();

  isMobile: boolean = false;

  // Listen to window resize event to detect screen size changes
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = window.innerWidth <= 768; // Mobile/tablet detection
  }

  // Check if it's mobile/tablet on component load
  ngOnInit() {
    this.isMobile = window.innerWidth <= 768;
  }

  // Total number of pages
  get totalPages(): number {
    return Math.ceil(this.totalItems / this.itemsPerPage);
  }

  // Generate the visible pagination pages
  getPaginationPages(): (number | string)[] {
    if (this.totalPages <= 1) {
      return [1]; // Only one page exists, so return just page 1
    }
  
    const delta = this.isMobile ? 1 : 2; // Show fewer pages on mobile/tablet
    const range = [];
    const left = this.currentPage - delta;
    const right = this.currentPage + delta;
  
    // Always include the first page
    range.push(1);
  
    // Ellipsis before the range
    if (left > 2) {
      range.push('...');
    }
  
    // Add pages between left and right range
    for (let i = Math.max(2, left); i <= Math.min(this.totalPages - 1, right); i++) {
      range.push(i);
    }
  
    // Ellipsis after the range
    if (right < this.totalPages - 1) {
      range.push('...');
    }
  
    // Always include the last page
    range.push(this.totalPages);
  
    return range;
  }

  // Page click event
  onPageClick(page: number | string) {
    if (page !== '...' && page !== this.currentPage) {
      this.currentPage = page as number;
      this.pageChange.emit(this.currentPage);
    }
  }

}
